<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="error-wrapper">
                <img class="error-img" :src="info.url" @click.stop="closeCollectCardError" />
            </div>
        </div>
    </div>

</template>

<script>

export default {

    name: 'CollectCardError',

    props: {
        info: { // 收集卡片错误
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },
    },

    watch: {

    },

    data() {
        return {

        }
    },

    mounted() {

    },

    methods: {

        closeCollectCardError() { // 关闭集卡出现错误
            this.$emit('emitEvent', {
                type: 'closeCollectCardError',
                data: null,
                options: null
            })
        },

    }

}

</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-wrapper {
    position: relative;
}

.error-img {
    width: 618px;
}

</style>
